import { graphql } from '~publish/graphql'

/**
 * What the queue card's Notes button reads to hide itself on a Post with no
 * Notes. The total runs its own backend count, so only screens that render
 * that button select it.
 */
export const PostNoteTotal = graphql(/* GraphQL */ `
  fragment PostNoteTotal on Post @_unmask {
    id
    collaborationNotesSummary {
      noteCount
    }
  }
`)
